import cn from 'classnames'
import { FC, ReactNode } from 'react'

import styles from './Container.module.scss'

interface IProps {
  verticalPadding?: boolean
  horizontalPadding?: boolean
  children?: ReactNode
}

const Container: FC<IProps> = ({ verticalPadding = true, horizontalPadding = true, children }) => (
  <section
    className={cn(styles.container, {
      [styles.verticalPadding]: verticalPadding,
      [styles.horizontalPadding]: horizontalPadding,
    })}
  >
    {children}
  </section>
)

export default Container
